import { render, staticRenderFns } from "./contractRejected.vue?vue&type=template&id=445ff60a&scoped=true"
import script from "./contractRejected.vue?vue&type=script&lang=js"
export * from "./contractRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ff60a",
  null
  
)

export default component.exports